export default __webpack_public_path__ + "static/media/camera.ee4b1b7b.svg";